import './stylev2.css';
import RightSideBar from "./components/RightSideBar";
import LeftMenu from "./components/LeftMenu";
import LogoWrapper from "./components/LogoWrapper";
import ChatWrapper from "./components/ChatWrapper";
import React, {useEffect, useState} from "react";
import {useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import {Constants}  from './Constants'
import {useStore} from "react-redux";
import btlogo from "./images/bottom-logo.svg";

function App() {
    let navigate = useNavigate();
    const [cookies] = useCookies([Constants.COOKIE_TOKEN]);
    useEffect(() => {
        if(!cookies.token){
            return navigate("/login");
        }
        let decodedValue = window.atob(cookies.token);

        if(decodedValue !== 'admin_admin'){
            return navigate("/login");
        }
    },[cookies, navigate]);

    const store = useStore();
    const [chatBucket , setChatBucket] = useState(store.getState().chats);
    useEffect(()=> {
        setChatBucket(store.getState().chats)
    },[store]);

    const pokeSibling = () => {
        setChatBucket(store.getState().chats);
    }

    useEffect(() => {
        console.debug('APP:VERSION:',process.env.REACT_APP_VERSION);
    }, []);

    // useEffect(() => {
    //     axios(Constants.API_URL)
    //         .then((response) => {
    //             const newData = {data:response.data};
    //             dispatch(addAllData(newData));
    //         })
    // }, []);

    return (
        <>
            {/*<div>*/}
            <div className="container" style={{marginBottom: '40px'}}>

                    <LogoWrapper/>
                    <LeftMenu/>
                    <ChatWrapper pokeSibling={pokeSibling}/>
                    <RightSideBar chatBucket={chatBucket}/>
                </div>

            <div className='bottom-sec' style={{
                height: "40px",
                clear: 'both',
                width: '100%',
                position: 'fixed',
                bottom: 0,
                backgroundColor:'#1A2D45'
            }}>
                <div className="bottom-text" style={{padding: '4px'}}>
                    <p>
                        <span style={{fontSize: '15px',paddingTop:'-3px'}}>Powered by &nbsp;</span>
                        <img src={btlogo} alt="" style={{
                            width: '55px', marginTop: '6px',
                            position: 'absolute'
                        }}/>
                    </p>
                </div>
            </div>
        </>
    );
}

export default App;
